import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { breakpoints, typeScale } from 'styles/globals';
import { ArrowRight } from 'components/icons';
import TextLink from 'components/TextLink';
import Heading from 'components/Heading';
import PageTitle from 'components/PageTitle';
var Crumb = styled(Heading).withConfig({
  displayName: "breadcrumbs__Crumb",
  componentId: "sc-vcq6t0-0"
})(["@media (max-width:", "){display:block;font-size:", ";font-weight:normal;}@media (max-width:", "){display:none;}"], breakpoints.s, typeScale.m, breakpoints.xxxs);
function Item(_ref) {
  var data = _ref.data,
    isLast = _ref.isLast;
  var link = data.link || '/browse';
  if (isLast) {
    return /*#__PURE__*/React.createElement(PageTitle, {
      size: "large",
      display: "inline-block",
      verticalAlign: "middle"
    }, data.title);
  }
  return /*#__PURE__*/React.createElement(Crumb, {
    dimmed: true,
    size: "large",
    verticalAlign: "middle",
    display: "inline-block",
    forwardedAs: "span"
  }, /*#__PURE__*/React.createElement(TextLink, {
    stealthy: true,
    as: NavLink,
    to: link
  }, data.title), /*#__PURE__*/React.createElement(ArrowRight, {
    vAlign: true,
    scale: 0,
    mx: "xs",
    dimmed: true
  }));
}
function Breadcrumbs(_ref2) {
  var items = _ref2.items;
  return items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.key,
      data: item,
      isLast: index === items.length - 1
    });
  });
}
export default Breadcrumbs;